'use strict';

module.exports = {
    showAddToCartModal: function(modalData, productPrices) {
        // Remove existing modal if present
        $('#add-to-cart-checkout-modal').remove();

        $('body').append(modalData);
        
        var bundleItems = $('.js-product-tile-bundle-checkbox:checked, .js-product-tile-bundle-radio:checked');
        if(bundleItems && bundleItems.length > 0) {
            $('.bundle-items-count').removeClass('d-none').html(bundleItems.length);
        }
        var addToCartModal = $('#add-to-cart-checkout-modal');
        addToCartModal.find('.everyday-price .value').html(productPrices.everyday);
        var memberPrice = addToCartModal.find('.member-price');
        if(productPrices.member && productPrices.member.trim() !== '') {
            memberPrice.removeClass('d-none').find('.value').html(productPrices.member);
        } else {
            addToCartModal.find('.everyday-price').addClass('font-weight--700').find('.label').addClass('d-none');
        }
        if(productPrices.hasPromo) {
            addToCartModal.find('.modal-pricing').addClass('has-promo');
        }

        addToCartModal.modal('show');

        // Modal close event
        addToCartModal.on('hidden.bs.modal', function () {
            $(this).remove();
        });

    }
};
